module.exports = __webpack_public_path__ + "img/bunny-ears-4.742584cc.svg";